module.exports = __webpack_public_path__ + "img/tower-broadcast.a82e838a.svg";